(function ($) {
  $(document).ready(function () {
    const mobileWidth = 768;
    $('.form-item__select').on('change', function (e) {

      $('#views-exposed-form-search-page-search').submit();
    });


    // $(window).click(function (e) {
    //
    // 	if (
    // 		$(e.target).is('.menu-search-container')
    // 		|| $(e.target).is('.main-menu__item.search')
    // 		|| $(e.target).is('.portal__menu-search')
    // 		|| $(e.target).is('.menu-submit')
    // 		|| $(e.target).is('.menu-search')
    // 	) {
    // 	} else {
    // 		if ($('html').width() < mobileWidth) {
    // 			$('.menu-search-wrapper').animate({"right": '-100%'});
    // 		} else {
    // 			$('.menu-search-wrapper').stop(true).fadeOut(300).promise().done(function () {
    //         $('#site-header').removeClass('menu-active');
    //       });
    // 		}
    //
    // 	}
    //
    // });
    //
    // $('.main-menu__item.search').unbind().bind('click', function () {
    //
    // 	if ($('html').width() < mobileWidth) {
    // 		$('.menu-search-wrapper').animate({"right": '0%'}, 300);
    // 	} else {
    //
    //     $('#site-header').removeClass('mega-menu-open')
    //     $('.main-menu__item').removeClass('active');
    //     $('.mega-menu').stop(true).fadeOut(300);
    //
    //     if($('#site-header').hasClass('menu-search-active')) {
    //
    //       $('.menu-search-wrapper').stop(true).fadeOut(300).promise().done(function () {
    //         $('#site-header').removeClass('menu-search-active menu-active mega-menu-opened');
    //         $('.menu-opacity').removeClass('hide');
    //         $('html, body').removeClass('lock');
    //       });
    //     }
    //     else {
    //       $('html, body').addClass('lock');
    //       $('.menu-opacity').addClass('hide');
    //       $('.menu-search-wrapper').stop(true).fadeIn(300);
    //       $('#site-header').addClass('menu-search-active');
    //     }
    // 	}
    // });

    $('.filter-item').unbind().click('click', function () {

      let query = '';
      // let typeQuery = '';
      const keyword = $('.search-form-field').val();
      const postType = $(this).attr('data-ref');
      const language = $('.search-language').val();

      if (keyword != '' && typeof keyword != 'undefined') {
        query = '&query=' + keyword + '&type=' + postType;
      } else {
        query = 'type=' + postType;
      }

      if( language == 'en') {
        window.location.href = drupalSettings.path.baseUrl + 'search?' + query;
      }
      else {
        window.location.href = drupalSettings.path.baseUrl + language + '/search?' + query;
      }
    });


    // const insertTimer = setInterval(function () {
    //
    // 	if ($('.views-exposed-form .js-form-item').length) {
    // 		let filterComponent = '';
    // 		$(".views-exposed-form > .js-form-item.form-item:first-of-type").append($('.total-count'));
    // 		$(".views-exposed-form .js-form-item.form-item:first-of-type").after('<div class="product-listing__filters"><div class="filters"></div></div>');
    //
    //
    // 		$('.views-exposed-form  .js-form-item.form-item').each(function (index) {
    // 			if (index != 0) {
    // 				filterComponent = $('.product-listing__filters .filters').append($(this));
    // 				$(this)
    // 			}
    // 		});
    //
    // 		$('.product-listing__filters').prepend($('.listing-count-wrapper'));
    // 		$('.product-listing__filters .filters').prepend($('.lbl-filter'));
    //
    //
    // 		$('.bottom-listing-count').prepend($('.top-listing-cout').html());
    //
    // 		$('.progress-bar>span').width(parseInt($('.search-list-count').html()) / parseInt($('.search-list-total').html()) * 100 + '%');
    //
    // 		$('.search-views').show();
    // 		clearInterval(insertTimer);
    // 	}
    // 	$('.search-views').show();
    // }, 500);

  });
})(jQuery);
